module.exports = __webpack_public_path__ + "static/media/manito-dinero-01.7dbf56f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/manito-dinero-01.png
// module id = 1833
// module chunks = 0